<template>
  <div class="page_admin_ages">
    <h1>Ceny v různých obdobích</h1>
    <div class="actions">
      <button @click="add" class="add" title="Přidat období">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <tabloid name="ages" :columns="columns" :data="ages">
      <template v-slot:startAt="{ row }">
        <inputerDate :paths="['ages', row.id, 'startAt']" :time="true" />
      </template>
      <template v-slot:endAt="{ row }">
        <inputerDate :paths="['ages', row.id, 'endAt']" :time="true" />
      </template>
      <template v-slot:priceCreated="{ row }">
        <inputerNumber :paths="['ages', row.id, 'priceCreated']" />
      </template>
      <template v-slot:dayPriceCreated="{ row }">
        <inputerNumber :paths="['ages', row.id, 'dayPriceCreated']" />
      </template>
      <template v-slot:priceDestroyed="{ row }">
        <inputerNumber :paths="['ages', row.id, 'priceDestroyed']" />
      </template>
      <template v-slot:dayPriceDestroyed="{ row }">
        <inputerNumber :paths="['ages', row.id, 'dayPriceDestroyed']" />
      </template>
      <template v-slot:actions="{ row }">
        <button @click="remove(row)" class="remove">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { data } from "../../store_utils";
import tabloid from "../../components/tabloid.vue";
import inputerNumber from "../../components/inputer-number.vue";
import inputerDate from "../../components/inputer-date";

export default {
  name: "admin_ages",
  components: {
    tabloid,
    inputerNumber,
    inputerDate
  },
  data: () => ({
    columns: {
      startAt: { title: "Od" },
      endAt: { title: "Do" },
      priceCreated: { title: "Fixní cena účastníka" },
      dayPriceCreated: { title: "Cena jednoho dne" },
      priceDestroyed: { title: "Poplatek za odebrání účastníka" },
      dayPriceDestroyed: { title: "Poplatek za odebrání jednoho dne" },
      actions: { title: "" },
    },
  }),
  computed: {
    ...mapState(["ages"])
  },
  methods: {
    add() {
      const id = data.newGuid();
      this.$store.commit("add", {
        paths: ["ages", id],
        value: {
          id: id,
          startAt: new Date(),
          endAt: new Date(),
          priceCreated: 10,
          priceDestroyed: 10,
          dayPriceCreated: 3,
          dayPriceDestroyed: 3
        }
      });
    },
    remove(age) {
      this.$store.commit("remove", {
        paths: ["ages", age.id]
      });
    }
  }
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_admin_ages
  @include table-view()
  grid-template-areas: "label actions" "table table"
  grid-template-columns: auto 1fr
  grid-column-gap: 1rem

  h1
    grid-area: label
  .actions
    grid-area: actions
  table
    grid-area: table
    .remove
      @include button-danger()
</style>